/**
 * Determines whether a URL/title likely represents a score report.
 * Uses simple substring patterns to avoid false refreshes after closing the modal.
 */
export const isScoreReport = (
  url?: string | null,
  title?: string | null
): boolean => {
  const urlLower = url?.toLowerCase() || "";
  const titleLower = title?.toLowerCase() || "";

  const scoreReportPatterns = [
    "scorereport",
    "score-report",
    "score report",
    "results",
    "score",
    "report",
  ];

  return scoreReportPatterns.some(
    (pattern) => urlLower.includes(pattern) || titleLower.includes(pattern)
  );
};
